import { GetAdventureWithListingQueryResult } from '../../../hooks/useQueries'

import { PrerenderedAdventure } from '../types'

export const normalizePrerenderedAdventure = (
  data: PrerenderedAdventure['data'],
): GetAdventureWithListingQueryResult['data']['adventure'] => {
  return {
    id: data.id.toString(),
    description: data.description,
    location: data.location,
    locationType: data.location_type,
    title: data.title,
    reviewScore: data.review_score,

    adventureType: {
      id: data.adventure_type.id.toString(),
      name: data.adventure_type.name,
      slug: data.adventure_type.slug,
      category: data.adventure_type.category,
    },

    // @ts-ignore -- TS can't cope that this may be either a GQL_StoryAdventure or GQL_ListingAdventure
    storyUrl: data.story_url && data.story_url,
    // @ts-ignore -- in GQL query we get the feature listing and other properties on the story field
    // In server-side rendering we're only interestd in the story title, since the listing is passed in separately
    story: data.story && {
      title: data.story.title,
      active: data.story.active,
    },

    storyteller: data.storyteller && {
      id: data.storyteller.id.toString(),
      firstName: data.storyteller.first_name,
      url: data.storyteller.url,

      avatar: {
        original: data?.storyteller?.avatar_url,
        thumb: data?.storyteller?.avatar_url,
        thumbLg: data?.storyteller?.avatar_url,
      },
    },
  } as GetAdventureWithListingQueryResult['data']['adventure']
}
